import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface UpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function UpgradeDialog({ open, onOpenChange }: UpgradeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center">Ready to add another brand? 🚀</DialogTitle>
          <DialogDescription className="text-center">
            You'll need an active subscription to manage multiple brands.
            Let's get you set up with a plan!
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col space-y-4 py-4">
          <Button 
            variant="default" 
            onClick={() => window.open("https://cal.com/aicreator/30min", "_blank")}
            className="w-full"
          >
            👉 Book a quick call
          </Button>
          <Button 
            variant="outline" 
            onClick={() => window.open("https://wa.link/a40gaa", "_blank")}
            className="w-full"
          >
            Message us on WhatsApp
          </Button>
        </div>
        <DialogFooter className="sm:justify-center">
          <Button 
            variant="ghost" 
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
